import React, { useState, useEffect } from 'react';
import { useControleDemanda } from '../context/ControleDemandaProvider';
import DetalhesDemanda from './DetalhesDemanda';
import ListagemVertical from './ListagemVertical';
import ItemDemanda from './ItemDemanda';

export default function ListaDemandas() {
  const { 
    demandas, 
    loading, 
    carregarDemandas, 
    statusDemandas 
  } = useControleDemanda();
  
  const [abaAtiva, setAbaAtiva] = useState('recebidas');
  const [demandaSelecionada, setDemandaSelecionada] = useState(null);
  const [filtros, setFiltros] = useState({
    busca: '',
    categoria: '',
    origem: ''
  });

  useEffect(() => {
    carregarDemandas();
  }, [carregarDemandas]);

  // Filtrar demandas por status usando dados da view
  const demandasFiltradas = demandas.filter(demanda => {
    const status = demanda.status_id || 1; // Default para status 1 (Recebida)
    
    let statusFiltro = false;
    switch (abaAtiva) {
      case 'recebidas':
        statusFiltro = status === 1; // Status 1 = Recebida
        break;
      case 'encaminhadas':
        statusFiltro = status === 3; // Status 3 = Encaminhada (corrigido)
        break;
      case 'concluidas':
        statusFiltro = status === 2; // Status 2 = Concluída (corrigido)
        break;
      default:
        statusFiltro = true;
    }

    // Aplicar filtros adicionais usando campos da view
    const buscaFiltro = !filtros.busca || 
      demanda.descricao?.toLowerCase().includes(filtros.busca.toLowerCase()) ||
      demanda.usuario_nome?.toLowerCase().includes(filtros.busca.toLowerCase()) ||
      demanda.endereco?.toLowerCase().includes(filtros.busca.toLowerCase()) ||
      demanda.categoria_nome?.toLowerCase().includes(filtros.busca.toLowerCase()) ||
      demanda.id?.toString().includes(filtros.busca);

    const categoriaFiltro = !filtros.categoria || 
      demanda.categoria_nome === filtros.categoria;

    const origemFiltro = !filtros.origem || 
      (filtros.origem === 'app' && demanda.tipo_usuario_origem === 1) ||
      (filtros.origem === 'whatsapp' && demanda.tipo_usuario_origem === 2);

    return statusFiltro && buscaFiltro && categoriaFiltro && origemFiltro;
  });

  const formatarData = (data) => {
    if (!data) return 'N/A';
    return new Date(data).toLocaleDateString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const getOrigemIcon = (demanda) => {
    if (demanda.tipo_usuario_origem === 1) return { icon: 'fas fa-mobile-alt', text: 'App', class: 'origem-app' };
    if (demanda.tipo_usuario_origem === 2) return { icon: 'fab fa-whatsapp', text: 'WhatsApp', class: 'origem-whatsapp' };
    return { icon: 'fas fa-question', text: 'N/A', class: 'origem-unknown' };
  };

  const getNomeUsuario = (demanda) => {
    return demanda.usuario_nome || 'Usuário não identificado';
  };

  const getStatusBadge = (demanda) => {
    const statusId = demanda.status_id;
    const statusNome = demanda.status_nome || 'Indefinido';
    let className = 'status-badge ';
    
    switch (statusId) {
      case 1:
        className += 'status-nova';
        break;
      case 2:
        className += 'status-concluida'; // Status 2 = Concluída (corrigido)
        break;
      case 3:
        className += 'status-encaminhada'; // Status 3 = Encaminhada (corrigido)
        break;
      default:
        className += 'status-default';
    }
    
    return { className, statusNome };
  };

  if (demandaSelecionada) {
    return (
      <DetalhesDemanda 
        demanda={demandaSelecionada}
        onVoltar={() => setDemandaSelecionada(null)}
      />
    );
  }

  return (
    <div className="lista-demandas">
      <div className="lista-header">
        <div className="abas-demandas">
          <button
            className={`aba-button ${abaAtiva === 'recebidas' ? 'active' : ''}`}
            onClick={() => setAbaAtiva('recebidas')}
          >
            <i className="fas fa-inbox"></i>
            Recebidas
            <span className="badge">
              {demandas.filter(d => d.status_id === 1).length}
            </span>
          </button>
          <button
            className={`aba-button ${abaAtiva === 'encaminhadas' ? 'active' : ''}`}
            onClick={() => setAbaAtiva('encaminhadas')}
          >
            <i className="fas fa-share"></i>
            Encaminhadas
            <span className="badge">
              {demandas.filter(d => d.status_id === 3).length}
            </span>
          </button>
          <button
            className={`aba-button ${abaAtiva === 'concluidas' ? 'active' : ''}`}
            onClick={() => setAbaAtiva('concluidas')}
          >
            <i className="fas fa-check-circle"></i>
            Concluídas
            <span className="badge">
              {demandas.filter(d => d.status_id === 2).length}
            </span>
          </button>
        </div>

        <div className="filtros-demandas">
          <div className="filtro-grupo filtro-busca-expandido">
            <div className="input-with-icon">
              <i className="fas fa-search"></i>
              <input
                type="text"
                placeholder="Buscar por descrição, protocolo, usuário, endereço ou categoria..."
                value={filtros.busca}
                onChange={(e) => setFiltros({...filtros, busca: e.target.value})}
                className="filtro-input filtro-input-expandido"
              />
            </div>
          </div>
          <div className="filtro-grupo">
            <select
              value={filtros.categoria}
              onChange={(e) => setFiltros({...filtros, categoria: e.target.value})}
              className="filtro-select"
            >
              <option value="">Todas as categorias</option>
              {[...new Set(demandas.map(d => d.categoria_nome).filter(Boolean))].sort().map(categoria => (
                <option key={categoria} value={categoria}>{categoria}</option>
              ))}
            </select>
          </div>
          <div className="filtro-grupo">
            <select
              value={filtros.origem}
              onChange={(e) => setFiltros({...filtros, origem: e.target.value})}
              className="filtro-select"
            >
              <option value="">Todas as origens</option>
              <option value="app">Aplicativo</option>
              <option value="whatsapp">WhatsApp</option>
            </select>
          </div>
        </div>
      </div>

      {loading ? (
        <div className="loading-container">
          <div className="loading-spinner"></div>
          <p>Carregando demandas...</p>
        </div>
      ) : (
        <div className="demandas-grid">
          {demandasFiltradas.length === 0 ? (
            <div className="empty-state">
              <i className="fas fa-inbox"></i>
              <h3>Nenhuma demanda encontrada</h3>
              <p>Não há demandas para exibir nesta categoria.</p>
            </div>
          ) : (
            <ListagemVertical
              items={demandasFiltradas}
              loading={loading}
              onItemClick={setDemandaSelecionada}
              renderItem={(demanda) => <ItemDemanda demanda={demanda} />}
              emptyMessage="Nenhuma demanda encontrada nesta categoria"
              loadingMessage="Carregando demandas..."
            />
          )}
        </div>
      )}
    </div>
  );
}